// Compatibility wrapper preserving the original `fetchConfig` / `fetchWorkflows`
// / `fetchWorkflow` names. The actual HTTP calls live in `./api-client.js`,
// which builds URLs from the runtime config so an out-of-tree frontend can
// point at a different backend without rewriting call sites.
//
// Workflow-related fetches default to passing the current UI language so the
// returned summary titles / step text match what the user is viewing. Call
// sites can still pass an explicit ``{ lang }`` to override.

import { getConfig, getWorkflow, listWorkflows } from "./api-client.js";
import { getLanguage } from "./i18n.js";

export async function fetchConfig() {
  return getConfig();
}

export async function fetchWorkflows(options = {}) {
  return listWorkflows({ lang: options.lang ?? getLanguage() });
}

export async function fetchWorkflow(workflowId, options = {}) {
  return getWorkflow(workflowId, { lang: options.lang ?? getLanguage() });
}
